
import { AlertTriangle, UserCog } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useProfileCheck } from "@/contexts/ProfileCheckContext";

interface ProfileCompletionAlertProps {
  isComplete: boolean;
}

export const ProfileCompletionAlert = ({ isComplete }: ProfileCompletionAlertProps) => {
  const { redirectToProfile } = useProfileCheck();
  
  if (isComplete) return null;
  
  // Create a handler function that calls redirectToProfile with 'booking' reason
  const handleRedirectToProfile = () => {
    redirectToProfile('booking');
  };
  
  return (
    <Alert variant="info" className="mb-4">
      <AlertTriangle className="h-4 w-4 mr-2 text-amber-500" />
      <AlertDescription className="flex flex-col gap-2">
        <p>To book this service, please complete your contact information (display name, phone, address, and location).</p>
        <Button 
          variant="outline" 
          size="sm"
          className="self-start bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100 hover:text-blue-800"
          onClick={handleRedirectToProfile}
        >
          <UserCog className="mr-2 h-4 w-4" />
          Complete Your Profile
        </Button>
      </AlertDescription>
    </Alert>
  );
};
